import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo.png'

const Footer = (props) => {
    return (
        <div className="tp-site-footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="footer-image">
                            <Link className="logo" to="/"><img src={Logo} alt="" /></Link>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="link-widget">
                            <ul>
                                <li><a href="https://www.linkedin.com/in/dr-oliver-edsberger-54496b20/" target="_blank"><i className="ti-linkedin"></i></a></li>
                                <li><a href="https://medium.com/@oliver.edsberger" target="_blank"><i className="ti-medium"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="copyright">
                            <p>© 2025. All rights reserved by Edsberger Consulting AB.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;